import React from 'react'
import styles from './WordDataTable.module.css'

const Table = (props) => {
  let morphDetails = ''
  if (props.content.morphologyDetail) {
    const split = props.content.morphologyDetail.split(', ')
    split.map(detail => {
      if (detail === 'unknown') {
        return null
      } else {
        morphDetails = (morphDetails === '') ? detail : morphDetails + ', ' + detail
        return null
      }
    })
  }
  
  
  const displayedData = (props.language === 'GRK') ? [
    ['Lemma', props.content.lexeme],
    ['SBL Transliteration', props.content.transSBL],
    ['GK #', props.content.GoodrickKohlenbergerNumbers],
    ['LouwNida #', props.content.LouwNidaNumbers]
  ] : [
    ['Manuscript', props.content.text],
    ['Transliteration', props.content.SBLstyleTransliteration],
    ['Morphology', morphDetails],
    ['Hebrew Reference', `${props.content.Heb_ref.book_id} ${props.content.Heb_ref.chapter_id}:${props.content.Heb_ref.verse_id}`],
    ['English Reference', `${props.content.KJV_ref.book_id} ${props.content.KJV_ref.chapter_id}:${props.content.KJV_ref.verse_id}`]
  ]
  return (
  <table className={styles.dialogTable}><tbody>
    {displayedData.map((row, index) => (<tr key={index} className={styles.row}><td className={styles.leftCell}>{row[0]}</td><td className={styles.rightCell}>{(typeof row[1] === "object")?`${row[1].book_id} ${row[1].chapter_id}:${row[1].verse_id}`:row[1]}</td></tr>))}
    </tbody>
  </table>
  )
}

export default Table;